module.exports = __webpack_public_path__ + "./images/c52f720e6769653b281c4055b70560d2.webp";